import Vue from 'vue';

async function getSSOToken(appName, accessToken) {
  const response = await fetch(`${this.axios.defaults.baseURL}/external-apps/${appName}/sso`, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` } }).catch(e => e);
  if (response instanceof Error) return;
  const json = await response.json();
  // eslint-disable-next-line consistent-return
  return json.ssoToken;
}

Vue.prototype.$ssoToken = getSSOToken;
